import React from 'react'
import { connect } from 'react-redux'
import { push, replace} from 'react-router-redux'
import { Link } from 'react-router'
import {
  loadOrganization,
  doClaimOrganization,
  doUpdateOnBoardingSteps,
  doSaveOrganization,
  doSendVerificationEmail,
  loadLoggedinUser,
  openLoginFormRequest,
  openSignupFormRequest
} from '../actions'
import { removeOnBoardingStep, objectToFormData } from '../utils/index'
import isLoggedIn from '../utils/index'
import Url from '../utils/Url'
import { FBPage } from 'facebook-plugins'
import { isEmpty } from 'lodash/lang'

import OrganizationDetailEditButtons from '../components/OrganizationDetailEditButtons'
import OrganizationDetailBanner from '../components/OrganizationDetailBanner'

import OrganizationDetailShareButtons from '../components/OrganizationDetailShareButtons'

import OrganizationFavBtn from '../components/OrganizationFavBtn';

import OrganizationDetailTextSection from '../components/OrganizationDetailTextSection'
import OrganizationDetailConnectSection from '../components/OrganizationDetailConnectSection'
import OrganizationDetailEditThumbnail from '../components/OrganizationDetailEditThumbnail'
import OrganizationDetailEditAccount from '../components/OrganizationDetailEditAccount'

import OrganizationDetailLocationSection from '../components/OrganizationDetailLocationSection';

import { asyncActions } from 'react-async-actions'
import DocumentMeta from 'react-document-meta'
import NotFound from './NotFound'


class ClaimEditButton extends React.Component {
  constructor(props) {
    super(props);
  }

  isClaimable = (props) => {
    const { user, claim, organization } = props;

    if((user && claim.user) && user.id != claim.user) {
      // User is logged in, claim exists for this organization
      // but does not belong to the currently logged in user.
      return false;
    }

    if(!claim.id && (user && user.organizationClaim)) {
      // User is logged in, claim does not exists for this organization
      // but the logged in user has already claimed an organization.
      return false;
    }

    if(claim.id && !user) {
      // Claim exists but not the user, which usually means anonymous user.
      return false;
    }

    return true;
  };

  openJoinModal = (e) => {
    e.preventDefault();
    const { organization } = this.props;
    const payload = {
      next: `/organizations/claim/${organization.db_id}`
    }

    this.props.openLoginFormRequest(payload);
  }

  checkUserVerifeid = (e) => {
    return;
    const { user, doSendVerificationEmail } = this.props

    if (user && !user.verified) {
      this.props.doSendVerificationEmail()
      e.preventDefault();
    }
  }

  render () {
    if(!this.isClaimable(this.props)) {
      return <span/>;
    }

    const { user, claim, organization } = this.props;
    const editLink = `/organizations/edit/${organization.db_id}`;
    const claimLink = `/organizations/claim/${organization.db_id}`;
    let content = '';

    if(claim.id) {
      if(user && user.id == claim.user && claim.status == 'approved') {
        content = (
          <Link onClick={this.props.showPageEdit} className="button button-primary button-edit-claim" to={editLink}>
            <i className="fa fa-pencil-square-o"></i> Edit your page
          </Link>
        );
      }

      if(user && !user.verified) {
        content = (
          <div>
            <p><strong>You need to verify your new email address before claiming your organization.</strong></p>
            <p>We have sent you an email with verification link.</p>
            <button onClick={() => { this.props.doSendVerificationEmail({claim_id: claim.id}); }} className="button button-primary">I did not receive it. Send Again!</button>
          </div>
        );
      }

      // We don't necessarily need to handle following condition as this
      // condition would be true only for a very short interval, usually under 10 seconds.
      //if(user && user.verified && claim.status != 'approved') {}

    } else if (!user) {
        content = (
          <button onClick={this.openJoinModal} className="button-wrap button-primary">
            <i className="fa fa-pencil-square-o"></i> Edit and manage your page
          </button>
        );
    } else {
        content = (
          <Link className="button button-primary" to={claimLink}>
            <i className="fa fa-pencil-square-o"></i> Edit and manage your page
          </Link>
        );
    }



    return (
    <div className="organizationDetail-claim">
      <div className="organizationDetail-claimDescription">
        {content}
      </div>
    </div>
    );
  }
}


const actionsToFire = (props) => [
    props.loadOrganization(props.params.id)
]


@connect(
  state => (state), // Can be replaces by mapStateToProps function as well.
  {
    push,
    replace,
    loadOrganization,
    doClaimOrganization,
    doUpdateOnBoardingSteps,
    doSaveOrganization,
    doSendVerificationEmail,
    openLoginFormRequest,
    openSignupFormRequest,
    loadLoggedinUser
  }
)
@asyncActions(actionsToFire)
class OrganizationDetail extends React.Component {
  state = {
    isEditMode: false,
    isClaimMode: false,
    editMode: 'page',
    updatedContent: {}
  };

  constructor(props) {
    super(props);
  }

  updateContent = (key, value) => {
    let newContent = this.state.updatedContent;
    newContent[key] = value;
    this.setState({ updatedContent: newContent});
  };

  saveOrganization = (e, isDone) => {
    isDone = (isDone === true);
    let content = objectToFormData(this.state.updatedContent);
    if(content) {
      this.props.doSaveOrganization(this.props.organization.db_id, content, (isDone ? false : this.state.isEditMode));
    }
    this.setState({ editMode: 'page' });
  };

  setMode = (props) => {
    let mode = {}
    const { location } = props

    mode.isClaimMode = (location.pathname.indexOf('/claim/') != -1) ? true : false;
    mode.isEditMode = (location.pathname.indexOf('/edit/') != -1) ? true : false;
    this.setState({ ...mode });
  };

  showPageEdit = e => {
    this.setState({ editMode: 'page' });
  };

  showThumbEdit = e => {
    this.setState({ editMode: 'thumb' });
  };

  showAccountEdit = e => {
    this.setState({ editMode: 'account' });
  };

  goBackFromEdit = e => {
    this.setState({
      'editMode': 'none',
    });
  };

  redirectToCanonicalUrl = () => {
    const { organization, routeParams } = this.props

    if (organization.isLoading) {
      return
    }
    // Organization is loaded now.

    if (!(this.state.isEditMode || this.state.isClaimMode)
     && organization.db_id ) {
     // Only redirect if slug param is missing.
     this.props.replace(`/organizations/${organization.db_id}/${organization.slug}`)
    }
  }

  createLoadOrganizationAction = (props) => {
      this.props.loadOrganization(props.routeParams.id).then(()=>{
        this.redirectToCanonicalUrl()
      })
  }
  componentWillReceiveProps(nextProps) {
    const { organization } = this.props
    if(this.props.routeParams.id != nextProps.routeParams.id) {
      this.createLoadOrganizationAction(nextProps)
    }
    this.setMode(nextProps)
  }


  componentWillMount() {
    this.createLoadOrganizationAction(this.props)
    this.setMode(this.props);
  }

  componentWillUpdate(prevState, prevProps) {
    if (typeof(window) !== "undefined") {
      window.scrollTo(0, 0);
    }

    if(this.state.isEditMode) {
      const { auth, organization, organizationClaim } = this.props;
      if(!(auth && auth.user)) {
        this.props.push(`/organizations/${this.props.routeParams.id}`);
      }
    }
  }

  componentDidMount() {
    if (typeof(window) !== "undefined") {
      window.scrollTo(0, 0);
    }
    this.setMode(this.props);
  }

  componentDidUpdate1() {
    let url = new Url;
    const { organization, organizationClaim, auth } = this.props;
    const { user } = auth;
    if( url.path.indexOf('claim') != -1 && organization && user) {


      if(isLoggedIn() && organizationClaim.id) {
        this.setState({ isClaimMode: true });
      }

      if(user.on_boarding && user.on_boarding.steps.indexOf('claim')) {
        let onboarding = removeOnBoardingStep(this.props.auth.user.on_boarding, 'claim');
        this.props.doUpdateOnBoardingSteps(onboarding);
      }
    }

  }

  render () {

    const { organization, browser, auth, organizationClaim } = this.props;


    if(organization.isLoading || organizationClaim.isLoading || auth.isLoading) {
      return <span />;
    }

    if(!organization.isLoading && organization.wasNotFound) {
      return <NotFound />
    }

    const { user } = auth;
    let region = '';

    const regions = this.props.organization.region_names;
    const googleMapKey = 'AIzaSyA3Xg-_aRZsRtgBGg38S7SQQhjjEaIOVUg';

    let mapUrl = '';

    let fullAddress = '';
    if (!isEmpty(regions)) {
      for (var i = regions.length - 1; i > -1; i--) {
        if (i == 0) {
          fullAddress += regions[i];
        } else {
          fullAddress += regions[i] + ', ';
        }
      }
    }

    // If organization has no address
    if (organization.address1 == '' && !isEmpty(regions)) {
      if (regions.length != 0) {
        mapUrl = `https://www.google.com/maps/embed/v1/place?q=${fullAddress}&key=${googleMapKey}`;
      }

    } else if ((!organization.address1 == '' && organization.state == '') || (!organization.address1 == '' && organization.city == '')) {
      mapUrl = `https://www.google.com/maps/embed/v1/place?q=${organization.address1}%20${region}&key=AIzaSyA3Xg-_aRZsRtgBGg38S7SQQhjjEaIOVUg`;

    } else {
      mapUrl = `https://www.google.com/maps/embed/v1/place?q=${organization.address1}%20${organization.city}%20${organization.state}%20${organization.zipcode}&key=AIzaSyA3Xg-_aRZsRtgBGg38S7SQQhjjEaIOVUg`;
    }


    let facebookPageBox = '';
    let organizationDetailFacebookStyle = 'organizationDetail-facebook';

    if(organization.facebook) {
      facebookPageBox = <FBPage appId="306265032880746" href={organization.facebook} width={700} tabs={['timeline', 'events', 'messages']}/>;
    }

    if (!organization.facebook) {
      organizationDetailFacebookStyle = 'organizationDetail-facebook no-facebook';
    }

    let editButtons = '';
    if(this.state.isEditMode) {
      editButtons = <OrganizationDetailEditButtons
                        saveOrganization={this.saveOrganization}
                        editMode={this.state.editMode}
                        showPageEdit={this.showPageEdit}
                        showThumbEdit={this.showThumbEdit}
                        showAccountEdit={this.showAccountEdit}
                        goBackFromEdit={this.goBackFromEdit}
                        organization={organization}
                        isEditMode={this.state.isEditMode}
                    />;
    }

    let claimEditButton = <ClaimEditButton user={user}
                                           showPageEdit={this.showPageEdit}
                                           claim={organizationClaim}
                                           organization={organization}
                                           push={this.props.push}
                                           doClaimOrganization={this.props.doClaimOrganization}
                                           doSendVerificationEmail={this.props.doSendVerificationEmail}
                                           openLoginFormRequest={this.props.openLoginFormRequest}
                                           openSignupFormRequest={this.props.openSignupFormRequest}
                                           isClaimMode={this.state.isClaimMode} />;
    if(this.state.isEditMode) {
      claimEditButton = '';
    }

    let page = '';

    let region_names = '';
    let region_city = '';
    let region_state = '';
    let org_location = '';




    let contentWrapperInnerClass = 'content-wrapper-inner';
    switch(this.state.editMode) {
      case 'account':
        page = <OrganizationDetailEditAccount updateContent={this.updateContent} organization={organization} user={user} saveOrganization={this.saveOrganization}/>;
        break;
      case 'thumb':
        contentWrapperInnerClass = 'content-wrapper-inner thumbnail-edit-mode';
        page = <OrganizationDetailEditThumbnail updateContent={this.updateContent} organization={organization} />;
        break;
      default:
        page = <div className="organization-detail-flex-parent">

          <div className="col01">
            <OrganizationDetailTextSection updateContent={this.updateContent} isEditMode={this.state.isEditMode} cssSuffix="about" sectionTitle="About" organization={organization} orgAttr="about" />

            <OrganizationDetailConnectSection updateContent={this.updateContent} isEditMode={this.state.isEditMode} cssSuffix="connect" sectionTitle="Connect" organization={organization} />


            <div className={organizationDetailFacebookStyle}>
              <div className="organizationDetail-facebookTitle">Facebook</div>
              <div className="organizationDetail-facebookDescription">
                {facebookPageBox}
              </div>
            </div>
          </div>



          <div className="col02">
            <OrganizationDetailTextSection updateContent={this.updateContent} isEditMode={this.state.isEditMode} cssSuffix="service" sectionTitle="Service Overview" organization={organization} orgAttr="service_overview" />




            <div className="organizationDetail-location">


              <OrganizationDetailLocationSection
              organization={organization}
              isEditMode={this.state.isEditMode}
              saveOrganization={this.saveOrganization}
              updateContent={this.updateContent} />



              <div className="organizationDetail-locationDescription">
                <iframe width="100%" height="275" frameBorder="0" style={{border:0}} src={mapUrl}></iframe>
              </div>
            </div>

            <div className="organization-detail-claim-2">{claimEditButton}</div>

          </div>

        </div>;
    };


    let meta = {
      title: 'WorldWideWomen | ',
      description: '',
      canonical: `https://worldwidewomen.co/organizations/${organization.db_id}/${organization.slug}`,
      meta: {
        property: {
          'og:type': 'organization',
          'og:image': organization.image_cover
        }
      },
      auto: {
        ograph: true,
      },
    }

    if (organization.seo_title) {
      meta.title = `${meta.title}${organization.seo_title}`
    } else {
      meta.title = `${meta.title}${organization.name}`
    }

    if (organization.seo_description) {
      meta.description = organization.seo_description
    } else {
      meta.description = organization.about
    }


    return (
      <div key={`${organization.name}-${organization.db_id}`} className="organizationDetail">
        <DocumentMeta {...meta} />
        <div className="content-wrapper">
          <OrganizationDetailBanner updateContent={this.updateContent} isEditMode={this.state.isEditMode} browser={this.props.browser} organization={organization} />
          {editButtons}
        </div>

        <div className="content-wrapper">
          <div className="organizationDetail-btnWrapperOuter">
            <OrganizationFavBtn
              routing={this.props.routing}
              browser={this.props.browser}
              auth={this.props.auth}
              db_id={this.props.organization.db_id}
            />

            <OrganizationDetailShareButtons routing={this.props.routing}
            browser={this.props.browser}
            auth={this.props.auth}
            organization={this.props.organization}
            />
          </div>
        </div>

        <div className="content-wrapper">
          <div className={contentWrapperInnerClass}>
            <div className="organizationDetail-auxWrapper">
              {page}
            </div>
          </div>

        </div>
      </div>
    );
  }
};


export default OrganizationDetail



// WEBPACK FOOTER //
// ./src/containers/OrganizationDetail.jsx